import React from 'react';
import clsx from 'clsx';

import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, {
    ContentColumn,
} from '@/layouts/ContentWrapper/ContentWrapper.component';
import Heading from '@/elements/Heading/Heading.component';
import Text from '@/elements/Text/Text.component';

import { IProps } from '@/blocks/HeroSearchBlock/HeroSearchBlock.interface';
import '@/blocks/HeroSearchBlock/HeroSearchBlock.styles.css';
import AutoSuggest from '@/components/AutoSuggest/AutoSuggest.component';

export const HeroSearchBlock: React.FC<IProps> = ({
    title,
    description,
    autoCompleteButtonText,
    autoCompletePlaceholder,
    autoCompleteApiUrl,
    autoCompleteRedirectUrl,
    className,
    ...blockWrapperProps
}) => {

    const isLocal = process.env.NODE_ENV === 'development' ? 'https://dev.missionaustralia.com.au/' : '';

    const handleSearchSubmit = (searchTerm: string) => {
        if (!searchTerm.trim()) {
            return; // Prevent empty searches
        }
        window.location.href = `${isLocal}${autoCompleteRedirectUrl}${encodeURIComponent(searchTerm)}`;
    };

    const handleSuggestionSelected = (suggestion: string) => {
        if (!suggestion.trim()) {
            return; // Prevent empty suggestions
        }

        window.location.href = `${isLocal}${autoCompleteRedirectUrl}${encodeURIComponent(suggestion)}`;
    }

    return (
        <BlockWrapper
            className={clsx('heroBannerBlock', className)}
            {...blockWrapperProps}
            layout="hero"
        >
            <ContentWrapper>
                <ContentColumn layout="two-thirds">
                    {title && (
                        <Heading level={1} className="heroBannerBlock__title" html={title} />


                    )}
                    {description && (
                        <Text className="heroBannerBlock__description" html={description} />
                    )}
                    <div className="heroBannerBlock__searchContainer"> {/* Optional: wrapper for spacing */}
                        <AutoSuggest
                            name="heroSearch"
                            label="Search the site"
                            placeholder={autoCompletePlaceholder}
                            apiUrl={autoCompleteApiUrl}
                            initialValue=""
                            onSearchSubmit={handleSearchSubmit}
                            onSuggestionSelect={handleSuggestionSelected}
                            buttonLabel={autoCompleteButtonText}
                            buttonLocation="external"
                        />
                    </div>
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};
